







import Vue from 'vue'
import BaseLayout from '@/layout/BaseLayout.vue'

export default Vue.extend({
  components: {
    BaseLayout,
  },
  metaInfo() {
    return { title: this.$tc('auth.accessBlockPageTitle') }
  },
})
